import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import React from "react";
import LatoRegular from "../../Assets/Fonts/Lato-Font/Lato-Regular.ttf";
import LatoBold from "../../Assets/Fonts/Lato-Font/Lato-Bold.ttf";
import Header from "../../Components/GeneratePdf/Header";
import Footer from "../../Components/GeneratePdf/Footer";

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  pagewapper: {
    position: "relative",
    height: "100%",
  },
  content: {
    // marginTop: "35px",
    display: "flex",
    width: "570px",
    alignItems: "left",
  },
  contenttitle: {
    fontFamily: "Lato",
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "30px",
    color: "#426B88",
  },
  wapper: {
    width: "567px",
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
  },
  mainContent: {
    flexGrow: 1,
    marginTop: "28px",
  },
  footer: {
    marginTop: "auto",
  },
  table: {
    width: "100%",
    // borderWidth: 1,
    // borderColor: '#ccc',
  },
  tableRow: {
    flexDirection: "row",
    paddingVertical: 2,
    alignItems: "center",
  },
  tableHeader: {
    paddingVertical: 1,
    fontWeight: 400,
    border: "0px",
    backgroundColor: "#245775",
    fontWeight: "bold",
    color: "white",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  headerCell: { color: "white", fontWeight: 400, paddingVertical: "5px" },
  cellQuestion: {
    width: "70%",
    fontSize: 10,
    color: "#394554",
    fontWeight: 400,
  },
  cellScore: { width: "7%", textAlign: "center", fontSize: 10 },
  cell: {
    padding: "10px",
    textAlign: "left",
  },

  rowEven: {
    backgroundColor: "#F1F3F3",
  },
  rowOdd: {
    backgroundColor: "#FFF",
  },
  redRectangle: {
    width: 17,
    height: 17,
    backgroundColor: "#C99212",
    borderRadius: "1.34px",
  },
  goldRectangle: {
    width: 17,
    height: 17,
    backgroundColor: "#FFD700",
    borderRadius: "1.34px",
  },
});

const truncateText = (text, limit) => {
  if (text.length <= limit) return text;
  return text.substring(0, text.lastIndexOf(" ", limit)) + "...";
};

const getLastFilledIndex = (scores) => {
  for (let i = scores.length - 1; i >= 0; i--) {
    if (scores[i] === 1) return i;
  }
  return -1;
};

const renderRectangle = (score, index, scores) => {
  const lastFilledIndex = getLastFilledIndex(scores);
  return index <= lastFilledIndex ? <View style={styles.goldRectangle} /> : null;
};

const QuadrantFlowStrength360 = ({ apiData = {} }) => {
  console.log("apiData in QuadrantFlowStrength360", apiData);
  const respondentName = apiData?.fullName?.split(' ')[0] || '[First Name]';
  
  return (
  <View style={styles.pagewapper}>
    <Header />
    <View style={styles.content}>
      <Text style={styles.contenttitle}>STRENGTH 360 IN FOCUS</Text>
      <View style={styles.wapper}>
        <Text>
        This chart isolates the items related to the Strength based on the OBSERVER ratings (SELF excluded). Focused results reflect the average of observer scores only. The response scale runs from 1 (Least) to 4 (Most). Any unselected statement will appear blank in the In Focus section.
        </Text>
      </View>
    </View>
    <View style={styles.mainContent}>
      <View style={[styles.tableRow, styles.tableHeader]}>
        <Text style={[styles.cell, styles.cellQuestion, styles.headerCell]}>
          Strength
        </Text>
        {[1, 2, 3, 4].map((num) => (
          <Text
            key={num}
            style={[styles.cell, styles.cellScore, styles.headerCell]}
          >
            {num}
          </Text>
        ))}
      </View>

      {data.map((item, index) => (
        <View
          key={index}
          style={[
            styles.tableRow,
            index % 2 === 0 ? styles.rowEven : styles.rowOdd,
          ]}
        >
          <Text style={[styles.cell, styles.cellQuestion]}>
            {item.question.replace(/\[First Name\]/g, respondentName)}
          </Text>
          {item.scores.map((score, idx) => (
            <View key={idx} style={[styles.cell, styles.cellScore]}>
              {renderRectangle(score, idx, item.scores)}
            </View>
          ))}
        </View>
      ))}
    </View>

    <Footer />
  </View>
);
};

export default QuadrantFlowStrength360;

const data = [
  {
    quadrant: "Strength",
    question: "When presented with a problem, [First Name] immediately starts working on it.",
    scores: [1, 1, 1, 1],
  },
  {
    quadrant: "Strength",
    question: "[First Name] makes decisions by focusing on what needs to get done.",
    scores: [1, 1, 1, 1],
  },
  {
    quadrant: "Strength",
    question: "[First Name] feels most fulfilled when personal tasks are completed.",
    scores: [1, 1, 1, 1],
  },
  {
    quadrant: "Strength",
    question: "[First Name] is motivated by winning.",
    scores: [1, 1, 1, 1],
  },
  {
    quadrant: "Strength",
    question: "[First Name] relies heavily on their drive to complete a project.",
    scores: [1, 1, 1, 0],
  },
  {
    quadrant: "Strength",
    question: "[First Name] respects people who deliver results.",
    scores: [1, 1, 1, 0],
  },
  {
    quadrant: "Strength",
    question: "[First Name] gains the most satisfaction when personal goals are reached.",
    scores: [1, 1, 1, 0],
  },
  {
    quadrant: "Strength",
    question: "[First Name] can lose momentum without clear, measurable goals.",
    scores: [1, 1, 0, 0],
  },
  {
    quadrant: "Strength",
    question: "[First Name] likes turning good ideas into action.",
    scores: [1, 0, 0, 0],
  },
  {
    quadrant: "Strength",
    question: "[First Name] likes turning good ideas into action.",
    scores: [1, 0, 0, 0],
  },
  {
    quadrant: "Strength",
    question: "[First Name] likes turning good ideas into action.",
    scores: [1, 0, 0, 0],
  },
];
